import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { Admincontent2, AdminContext } from '../../../containers/Admin';
import { TinyProps, useTiny } from '../../../../utils/hooks/useTiny';
import { Input } from '../../../ui/form/Input';
import { Button } from '../../../ui/button/Button';
import { ButtonGroup } from '../../../ui/button/ButtonGroup';
import { getSeoText } from '../../../../utils/seo/utils';

//update
import { getAdminClient } from '../AdminApolloClient';
import { gql, useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { UPDATE_PAGECONTENT_MUTATION } from '../../../../../client/__graphql__/mutations/updatePageContent';
import { H2 } from '../../HeaderTitle';
import { checkOfficeTag } from '../../../../utils/helpers/checkOfficeTag';

const client = getAdminClient();

export const EditorForm = React.memo(
  (props: {
    page_content: any;
    urltag: string;
    show_cancel?: boolean;
    style?: any;
    OnGoToImages?: any | null;
    backup?: any;
  }) => {
    const [contentData, setContentData] = useState(!props.backup ? props.page_content : props.backup);
    const [contentType, setContentType] = useState(
      props.page_content.type_data
    );

    //const history = useHistory();
    const context = useContext(AdminContext);
    const tiny = useTiny();

    const [submit, { error: submitError, loading: submitLoading, data: submitData },
    ] = useMutation(UPDATE_PAGECONTENT_MUTATION, {
      client,
      onCompleted: (data: any) => {
        //history.push(`/admin/${props.urltag}`);
        if (data?.updateNdPageContent?.success) {
          alert('updated');
        }
      },
    });

    const handleSubmit = (e: any) => {
      e.preventDefault();
      //console.log(contentData);
      submit({
        variables: {
          input: {
            id: contentData.id,
            type: contentType?.type!,
            title: contentData?.title,
            ingress: contentData?.ingress,
            content: contentData?.content,
            image: contentData?.image,
            officetag: checkOfficeTag(props.urltag),
            seoTitle: getSeoText(contentData?.title),
            seoText: (contentType?.edit_ingress ? getSeoText(contentData?.ingress) : getSeoText(contentData?.content))
          },
        },
      });
    };

    useEffect(() => {
      setContentData({
        ...contentData,
        [tiny.data.name]: tiny.data.value,
      });
    }, [tiny.data]);

    if (tiny.tinyLoaded) {
      if (contentType?.edit_ingress) tiny.triggerTiny('#ingress', 200);

      if (contentType?.edit_text) tiny.triggerTiny('#content');
    }

    const OnClickImage = () => {
      if (props.OnGoToImages) {
        props.OnGoToImages(contentData);
      }
    }

    const onChange = (e: any) => {
      setContentData({
        ...contentData,
        [e.target.name]: e.target.value,
      });
    };

    if (!context.adminState.loggedIn.status) {
      return <div></div>;
    }

    return (
      <>
        <Admincontent2>
          <EditorH2>Rediger {contentType?.title}</EditorH2>
          <Editor style={props.style}>
            <form>
              {contentType?.edit_image && props.OnGoToImages ? (
                <TopButtonWrapper>
                  <Button type="primary" style={{ cursor: 'auto' }} colorTheme="gray">
                    Rediger Tekst
                  </Button>
                  <Button onClick={OnClickImage} type="primary" colorTheme="gold">
                    Rediger bilder
                  </Button>
                </TopButtonWrapper>
              ) : null}
              <InputElement>
                <h2>Tittel</h2>
                <Input
                  name="title"
                  value={contentData?.title}
                  onChange={onChange}
                />
                <div style={{ marginBottom: '18px' }}></div>
              </InputElement>
              {contentType?.edit_ingress ? (
                <InputElement>
                  <div style={{ marginBottom: '30px', marginTop: '-56px' }}></div>
                  <h2>Ingress</h2>
                  <textarea
                    id="ingress"
                    name="ingress"
                    defaultValue={contentData?.ingress}
                  ></textarea>
                  <div style={{ marginBottom: '18px' }}></div>
                </InputElement>
              ) : null}
              {contentType?.edit_text ? (
                <InputElement>
                  <div style={{ marginBottom: '18px', marginTop: '-24px' }}>
                    <h2>Beskrivelse</h2>
                  </div>
                  <textarea
                    id="content"
                    name="content"
                    defaultValue={contentData?.content}
                  ></textarea>
                </InputElement>
              ) : null}
              <EditButtonWrapper>
                {props.show_cancel ? (
                  <Button
                    type="primary"
                    as="link"
                    to={`/admin/${props.urltag}`}
                    /* to= path ===  */
                    colorTheme="gold"
                    style={{ position: 'absolute', left: '39em' }}
                  >
                    Avbryt
                  </Button>
                ) : null}
                <Button onClick={handleSubmit} type="primary" colorTheme="gold">
                  Oppdater
                </Button>
              </EditButtonWrapper>
            </form>
          </Editor>
        </Admincontent2>
      </>);
  },
  (prevState, nextState) =>
    prevState.page_content.id === nextState.page_content.id
);

export const Editor = styled.div`
  overflow: auto;
  margin: 0 auto;
  width: 800px;
  padding-bottom: 15px;
  img {
    width: 100%;
  }

  h1 {
    padding: 10px 0px;
    margin: 0 auto;
  }
`;

export const EditorH2 = styled(H2)`
  padding: 10px 0px;
  margin: 0 auto;
`;

export const EditButtonWrapper = styled.div`
  margin-top: 12px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const TopButtonWrapper = styled.div`
  margin-top: 12px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #E8C893;

  button {
    :not(:last-child){
      margin-right: 15px;
    }
  }
`;

export const InputElement = styled.div`
  padding: 2em 0 0;
  color: ${({ theme }) => theme.colors.white};
  h2 {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const ImageUpload = styled.div`
  position: relative;
  min-height: 200px;
  &:before {
    content: '';
    position: absolute;
    background-color: rgba(255, 255, 255, 0.3);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: 100px;
    background-repeat: no-repeat;
    background-image: url(https://www.pinclipart.com/picdir/big/335-3352982_png-file-file-upload-icon-svg-clipart.png);
    background-position: center;
  }
`;

export default EditorForm;

